import Cookies from 'universal-cookie';
import { useState, createContext } from 'react';

export interface AuthContextValue {
  auth: string | false | null | undefined;
  setAuth: (token: string | false | null) => void;
}

const AuthContext = createContext<AuthContextValue>({} as AuthContextValue);

type Props = {
  children?: React.ReactNode;
};

export const AuthProvider = ({ children }: Props) => {
  const cookies = new Cookies();
  const defaultAuth = cookies.get('megi-authorization');

  const [auth, setAuth] = useState<string | false | null | undefined>(defaultAuth);

  const handleSetAuth = (token: string | false | null) => {
    if (!token) {
      cookies.remove('megi-authorization', { path: '/' });
      setAuth(null);
      return;
    }
    // set age to 1 year
    cookies.set('megi-authorization', token, { path: '/', maxAge: 31556952 });
    setAuth(token);
  };

  return <AuthContext.Provider value={{ auth, setAuth: handleSetAuth }}>{children}</AuthContext.Provider>;
};

export default AuthContext;
